import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { MDBModalRef, ToastService } from "ng-uikit-pro-standard";
import { FirebaseService } from "src/app/core/firebase/firebase.service";
import { Venue } from "src/app/core/venue/venue.model";
import { City } from "src/app/core/city/city.model";
import { AppService } from "src/app/core/app/app.service";
import { VenueBuilder } from "src/app/core/venue/venue.builder";
import { Observable } from "rxjs";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { environment } from "src/environments/environment";

@Component({
  selector: "ll-add-venue-form",
  templateUrl: "./add-venue-form.component.html",
  styleUrls: ["./add-venue-form.component.scss"]
})
export class AddVenueFormComponent implements OnInit {
  venue: Venue;
  image = "";
  title = "Add Venue";
  button = "Add";
  form: FormGroup;
  bannerImage = "";
  builder: VenueBuilder;
  constructor(
    public fb: FirebaseService,
    public app: AppService,
    public dialogRef: MatDialogRef<AddVenueFormComponent>,
    private toast: ToastService
  ) {}

  get city(): City {
    return this.app.state.city;
  }
  get venues$(): Observable<Venue[]> {
    return this.app.state.venues$;
  }

  get name(): string {
    return this.form.controls.name.value;
  }
  get isActive(): boolean {
    return this.form.controls.isActive.value;
  }
  get redirect(): boolean {
    return this.form.controls.redirect.value;
  }
  get redirectUrl(): string {
    return this.form.controls.redirectUrl.value;
  }

  get bannerRedirectUrl(): string {
    return this.form.controls.bannerRedirectUrl.value;
  }

  get isBannerRedirectActive(): boolean {
    return this.form.controls.isBannerRedirectActive.value;
  }

  get thumbnail(): string {
    return this.form.controls.thumbnail.value;
  }
  get description(): string {
    return this.form.controls.description.value;
  }

  ngOnInit() {
    this.builder = new VenueBuilder();
    this.create();
  }

  shouldShowMoveVenueCreation() {
    return this.app.state.permissions.includes(environment.moveVenueCreation);
  }

  onClickDashboardRedirect() {
    window.location.href = `${environment.ticketingDashboardBaseURL}/dashboard/city`;
  }

  create() {
    this.builder.setCity(this.city).setCreatedBy(this.app.state.user.name);
    this.builder.setRank(this.city.totalVenues);
    this.image = "";
    this.bannerImage = "";
    this.form = new FormGroup({
      name: new FormControl(""),
      isBannerActive: new FormControl(false),
      isBannerRedirectActive: new FormControl(false),
      bannerRedirectUrl: new FormControl(""),
      isActive: new FormControl(true),
      redirect: new FormControl(false),
      thumbnail: new FormControl(""),
      description: new FormControl(""),
      redirectUrl: new FormControl("")
    });
  }

  imageSelected = (): boolean => this.image != "";
  bannerSelected = (): boolean => this.bannerImage != "";

  invalidName(): boolean {
    if (this.name == "") return true;
    return false;
  }

  duplicateName(venues: Venue[]): boolean {
    return venues
      .filter(venue => venue.city.id == this.city.reference.id)
      .map(venue => venue.name.toLowerCase())
      .includes(this.name.toLowerCase());
  }

  invalidRedirectUrl(): boolean {
    return this.redirect && this.redirectUrl == "";
  }
  validate(venues: Venue[]) {
    if (this.invalidName())
      return this.toast.error(
        "Please provide a valid venue name.",
        "Invalid Venue Name",
        { opacity: 1 }
      );
    if (this.duplicateName(venues))
      return this.toast.error(
        "A venue with that name has already been created in this city.",
        "Duplicate Venue Error",
        { opacity: 1 }
      );
    if (this.image == "")
      return this.toast.error(
        "Please provide an image for the venue!",
        "Invalid Image Provided",
        { opacity: 1 }
      );
    if (this.invalidRedirectUrl())
      return this.toast.error(
        "Please provide a url when redirecting.",
        "Redirection Error",
        { opacity: 1 }
      );

    return this.submit(venues.length);
  }

  error(st: string) {
    this.toast.error(st);
  }

  isValid(input: string) {
    return /^[a-zA-Z][a-zA-Z\s\\']*$/.test(input);
  }

  async submit(rank: number) {
    const venueBuilder: VenueBuilder = this.builder.create(
      this.form.value,
      this.image,
      this.bannerImage,
      rank
    );

    await this.app.state.onAddVenue(venueBuilder.build());

    this.dialogRef.close();
    this.toast.success("Venue update was successful.", "Success", {
      opacity: 1
    });
  }

  get isBannerActive(): boolean {
    return this.form.controls.isBannerActive.value;
  }

  async selectBannerImage(event) {
    this.bannerImage = await this.app.fb.saveImage(
      event.target.files[0],
      "banner_ads/"
    );
  }

  async selectImage(event) {
    this.image = await this.fb.saveImage(
      event.target.files[0],
      "venue_images/"
    );
  }
}
